import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';

import API from '../repository';
import AuthClientUtils from '../utils/Auth/auth-client';

import { useAuth } from './AuthContext';

const CurrentCoffeeContext = createContext();

const CoffeeContextProvider = (props) => {
  const { user } = useAuth();
  const [currentCoffeeList, setCurrentCoffeeList] = useState([]);
  const [currentCoffeeDate, setCurrentCoffeeDate] = useState(new Date());
  const [finishCoffeeDate, setFinishCoffeeDate] = useState(new Date());
  const [currentCoffeeType, setCurrentCoffeeType] = useState('');
  const [currentCoffeeListError, setCurrentCoffeeListError] = useState(null);

  const endDateCalculation = (init, frecuency) => {
    let now = new Date(init);
    now.setDate(now.getDate() + frecuency * 7);
    return now;
  };

  const getCurrentCoffeeList = useCallback(async () => {
    const handleCurrentCoffeeListError = (error) => {
      setCurrentCoffeeListError(error);
    };
    try {
      const { groups, groupDate, currentRouletteType } = await API().get({
        path: 'coffees/list-auto',
      });
      if (!groupDate || !groups || !currentRouletteType) {
        return handleCurrentCoffeeListError(`There is no available roulette`);
      }

      if (groups.length) {
        let myPair = groups.find((group) =>
          group.some((u) => u.email === user.email),
        );

        if (myPair) {
          groups.sort((x, y) => {
            return x === myPair ? -1 : y === myPair ? 1 : 0;
          });
          groups[0][1].email === user.email && groups[0].reverse();
        }

        setCurrentCoffeeList(groups);
        setCurrentCoffeeDate(new Date(groupDate));
        setFinishCoffeeDate(new Date(endDateCalculation(groupDate, 1)));
        setCurrentCoffeeType(currentRouletteType);
      }
    } catch (error) {
      handleCurrentCoffeeListError(error);
    }
  }, [user]);

  const onShuffleClick = useCallback(
    async (rouletteType) => {
      const postPairs = async () => {
        const query = rouletteType ? { team: rouletteType } : {};
        await API().post({ path: 'groups', query });
        getCurrentCoffeeList();
      };
      await postPairs();
    },
    [getCurrentCoffeeList],
  );

  useEffect(() => {
    AuthClientUtils.isLoggedIn() && user && getCurrentCoffeeList();
  }, [getCurrentCoffeeList, user]);

  const value = useMemo(
    () => ({
      currentCoffeeList,
      currentCoffeeDate,
      finishCoffeeDate,
      currentCoffeeType,
      getCurrentCoffeeList,
      onShuffleClick,
    }),
    [
      currentCoffeeList,
      currentCoffeeDate,
      finishCoffeeDate,
      currentCoffeeType,
      getCurrentCoffeeList,
      onShuffleClick,
    ],
  );

  if (currentCoffeeListError) {
    console.log(currentCoffeeListError);
  }

  return <CurrentCoffeeContext.Provider {...props} value={value} />;
};

const useCoffee = () => {
  const context = useContext(CurrentCoffeeContext);
  if (context === undefined) {
    throw new Error(`useCoffee must be used within a CoffeeContextProvider`);
  }
  return context;
};

export { useCoffee, CoffeeContextProvider };
